import { React } from 'Imports';
import { isEncompass } from '$Utilities/integrationPlatform';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { IVideoEventServiceInjectedProps, VideoEventService } from '$State/VideoEventFreezerService';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

const styles = require('./NavigationButtons.scss') as {
    navigationButtonsContainerGeotab: string;
    navigationButtonsContainerEncompass: string;
    outlinedButton: string;
    textButton: string;
    buttonIcon: string;
    flexEnd: string;
};

interface NavigationButtonsProps {
    eventDisplayId: string | undefined;
    isVideoRecall?: boolean;
    onSelectVideoEvent: (eventId: string, goBack: boolean, addHistoryState: boolean) => void;
}

const _NavigationButtons = (props: NavigationButtonsProps & IVideoEventServiceInjectedProps) => {
    const [sequence, setSequence] = useState(0);
    const [allFilteredIds, setAllFilteredIds] = useState<string[]>([]);

    useEffect(() => {
        const { listofEventIdResult } = props.videoEvents.getState();
        const allIds = listofEventIdResult?.data?.videoEventDisplayIdList ?? [];
        const currentId = props.eventDisplayId || '';

        setAllFilteredIds(allIds);
        setSequence(allIds.indexOf(currentId) ?? 0);

        return () => {
            setAllFilteredIds([]);
            setSequence(0);
        };
    }, [props.eventDisplayId, props.videoEvents]);

    const handleOnClick = (direction: number) => {
        if (allFilteredIds.length <= 1 || (sequence <= 0 && direction == -1) || (sequence >= allFilteredIds.length - 1 && direction == 1))
            return;

        props.onSelectVideoEvent(allFilteredIds[sequence + direction], false, false);
    };

    const previousButtonText = isEncompass ? 'Previous' : `Previous ${props.isVideoRecall ? 'Recall' : 'Event'}`;
    const nextButtonText = `Next ${props.isVideoRecall ? 'Recall' : 'Event'}`;

    return (
        <div className={isEncompass ? styles.navigationButtonsContainerEncompass : styles.navigationButtonsContainerGeotab}>
            <button
                className={isEncompass ? styles.textButton : styles.outlinedButton}
                onClick={() => handleOnClick(-1)}
                disabled={sequence <= 0 || allFilteredIds.length <= 1}
            >
                <FontAwesomeIcon icon={faArrowLeft} className={styles.buttonIcon} />
                <span>{previousButtonText}</span>
            </button>

            <button
                className={`${isEncompass ? classNames(styles.textButton, styles.flexEnd) : styles.outlinedButton}`}
                onClick={() => handleOnClick(1)}
                disabled={sequence < 0 || sequence === allFilteredIds.length - 1 || allFilteredIds.length <= 1}
            >
                <span>{nextButtonText}</span>
                <FontAwesomeIcon icon={faArrowRight} className={styles.buttonIcon} />
            </button>
        </div>
    );
};

const NavigationButtons = VideoEventService.inject(_NavigationButtons);

export default NavigationButtons;
